(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ll-disclosure], .ll-nav__dropdown').forEach((details) => {
      if (details.dataset.llReady) return;
      details.dataset.llReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll('[data-ll-disclosure][open], .ll-nav__dropdown[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          details.open = false;
          details.querySelector('summary').focus();
        }
      });
      details.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { details.open = false; }));
    });
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-ll-disclosure][open], .ll-nav__dropdown[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
